import { call, put, takeLatest } from "redux-saga/effects";
import { getFinancialReport } from "src/api";
import { Constant } from "src/lib/Constants";
import {
  FINANCIAL_REPORT_FETCH_ERROR,
  FINANCIAL_REPORT_FETCH_LOADING,
  FINANCIAL_REPORT_FETCH_SUCCESS,
} from "src/redux/types";

function* financialReport(action) {
  console.log("first financialReport");
  yield put({
    type: FINANCIAL_REPORT_FETCH_LOADING,
    payload: true,
  });
  try {
    let res = yield call(getFinancialReport, action.payload);
    let response = res.response.data;
    console.log("getFinancialReport", response);
    if (response.status === Constant.RESPONSE_STATUS.SUCCESS) {
      yield put({
        type: FINANCIAL_REPORT_FETCH_SUCCESS,
        payload: response.result,
      });
    } else {
      yield put({
        type: FINANCIAL_REPORT_FETCH_ERROR,
        payload: response.message,
      });
    }
  } catch (error) {}
}

export function* financialSaga() {
  yield takeLatest("FINANCIAL_REPORT_FETCH_ACTION", financialReport);
}
